import { object, InferType } from 'yup'

import { roundToPrecision } from '../helpers'

import { UNIT_MAP } from './remainingValue'
import { toleranceSchemaV1, unitValueSchema } from './tolerance'

export const cadenceValueSchema = object({
  tolerance: toleranceSchemaV1.nullable(),
  days: unitValueSchema,
  months: unitValueSchema,
  flying_hours: unitValueSchema,
  cycles: unitValueSchema,
  landings: unitValueSchema,
})

const CADENCE_VALUE_FIELDS = [
  'months',
  'days',
  'flying_hours',
  'cycles',
  'landings',
]

export const getCadenceAsStringArray = (
  cadenceValue: CadenceValue
): string[] => {
  const result: string[] = []
  CADENCE_VALUE_FIELDS.forEach((field) => {
    if (cadenceValue[field]) {
      result.push(`${roundToPrecision(cadenceValue[field])} ${UNIT_MAP[field]}`)
    }
  })
  return result
}

export const getCadenceAsFlatDict = (cadenceValueSchema: CadenceValue) => {
  const result: Record<string, number | null> = {}
  const fields = ['months', 'days', 'flying_hours', 'cycles', 'landings']

  const fieldMap = {
    months: 'Months',
    days: 'Days',
    flying_hours: 'Hours',
    cycles: 'Cycles',
    landings: 'Landings',
  }
  fields.forEach((field) => {
    if (cadenceValueSchema[field]) {
      result['interval' + fieldMap[field]] = roundToPrecision(
        cadenceValueSchema[field]
      )
    } else {
      result['interval' + fieldMap[field]] = null
    }
  })
  // Add tolerance with the same logic on each field
  if (cadenceValueSchema.tolerance) {
    const tolerance = cadenceValueSchema.tolerance
    fields.forEach((field) => {
      if (tolerance[field]) {
        result['tolerance' + fieldMap[field]] = roundToPrecision(
          tolerance[field]
        )
      } else {
        result['tolerance' + fieldMap[field]] = null
      }
    })
  } else {
    fields.forEach((field) => {
      result['tolerance' + fieldMap[field]] = null
    })
  }

  return result
}

export const areCadenceValuesEqual = (
  cadenceValue1: CadenceValue,
  cadenceValue2: CadenceValue
) => {
  if (!cadenceValue1 || !cadenceValue2) {
    return cadenceValue1 == cadenceValue2
  }
  for (const field of CADENCE_VALUE_FIELDS) {
    if (cadenceValue1[field] !== cadenceValue2[field]) {
      return false
    }
  }
  if (cadenceValue1.tolerance || cadenceValue2.tolerance) {
    return areCadenceValuesEqual(
      cadenceValue1.tolerance,
      cadenceValue2.tolerance
    )
  }
  return true
}

export type CadenceValue = InferType<typeof cadenceValueSchema>
